import { useState, useEffect } from 'react';
import { ManageBranchService } from "../api/services";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const SearchCards = () => {
  const navigate = useNavigate();
  const [cardName, setCardName] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [studentData, setStudentData] = useState(null);
  const [showMobile, setShowMobile] = useState(false);
  const [activeTab, setActiveTab] = useState('calls');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [currentStudentId, setCurrentStudentId] = useState(null);
  const [showSwapPopup, setShowSwapPopup] = useState(false);
  const [showRechargePopup, setshowRechargePopup] = useState(false);
  const [isCardAvailable, setIsCardAvailable] = useState(false);
  const [newCardNumber, setNewCardNumber] = useState("");
  const [newCardId, setNewCardId] = useState("");
  const [IsLoading, setIsLoading] = useState(false);


  const generateTransactionId=()=>{
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 10000);
        return `TRANS_${timestamp}_${random}`;
  }
  const handleViewMobile = (item) => {
    setSelectedStudent(item);
    setShowPopup(true);
  };
  const handleRechargeCard = (item)=>{
    const transactionId = generateTransactionId();

  }
  const handleVerifyCard = (newCardNumber) =>{
    const payload = {
        "card_name": newCardNumber
    }
    setIsLoading(true);
    ManageBranchService.VerifyCard(payload).then((res) => {
            // setStudentData(res.data.results || null);
            // setShowMobile(false);
            // setLoading(false);
            if (res.data.code == "201") {
                    alert(res.data.error_message);
                }else if(res.data.code == "200"){
                    setIsCardAvailable(res.data.results['isCardAvailable'])
                    setNewCardId(res.data.results['card_id'])
                    
                    if(!(res.data.results['isCardAvailable'])){
                      alert("Card is not available")
                    }
                } else {
                    alert(res.data.error_message);
                }
                setIsLoading(false);
          })
          .catch((err) => {
            console.error("Fetch failed:", err);
            setError('Failed to fetch student data');
            setIsLoading(false);
          });
  }

  const handleRowClick = (studentId) => {
    setCurrentStudentId(studentId);
    setShowPopup(true);
  };
const RechargeCardPopup = ({ data, onClose }) => {
  const [rechargeAmount, setRechargeAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  if (!data) return null;

  // Generate amount options dynamically based on balance
  const generateAmountOptions = () => {
    const balance = parseFloat(data.balance) || 0;
    const options = [];

    for (let i = 100; i <= balance; i += 100) {
      options.push(i);
    }

    if (balance % 100 !== 0 && balance > 0) {
      options.push(balance);
    }
    return options;
  };

  const amountOptions = generateAmountOptions();

  const handleSubmit = () => {
    if (!rechargeAmount || rechargeAmount === "") {
      setAmountError("Please select a recharge amount.");
      return;
    }

    setAmountError(""); // clear error
    setShowConfirmPopup(true);
  };

  const handleConfirmRecharge = () => {
    setShowConfirmPopup(false);

    const rechargePaylod = {
      "transaction_id" : generateTransactionId(),
      "card_id": studentData.card_id,
      "transfer_to": studentData.branch_id,
      "amount": rechargeAmount,
      "transaction_type":"AGENT"
    };
    setIsLoading(true);
    ManageBranchService.AddBalanceToCard(rechargePaylod).then((res) => {
        alert("Card recharged successfully!");
        setIsLoading(false);
        })
        .catch((err) => {
        setError('Failed to Recharge card');
        setIsLoading(false);
        });

    onClose();
  };

  return (

    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "650px",
          background: "#ffffff",
          borderRadius: "8px",
          padding: "25px",
          boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
        }}
      >
         {/* HEADER */}
        <div
          style={{
            background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
            borderRadius: "8px",
            padding: "14px 20px",
            marginBottom: "20px",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: "600",
              color: "#ffffff",
            }}
          >
            Recharge Card
          </h2>
        </div>

        {/* STUDENT BOX */}
        <div
          style={{
            background: "#f9f9f9",
            padding: "18px",
            borderRadius: "6px",
            border: "1px solid #e5e5e5",
            marginBottom: "25px",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <strong>Card No:</strong> {data.card_name}
            <span style={{ float: "right" }}>
              <strong>Balance:</strong> ₹{data.balance}
            </span>
          </div>

          <div style={{ marginBottom: "6px" }}>
            <strong>Student Name:</strong> {data.student_name}
          </div>

          <div style={{ marginBottom: "6px" }}>
            <strong>Parent:</strong> {data.parent_name}
          </div>

          <div>
            <strong>Relationship:</strong> {data.parent_relation}
          </div>
        </div>

        {/* LABEL */}
        <h3
          style={{
            marginBottom: "15px",
            fontSize: "18px",
            color: "#444",
            fontWeight: 600,
          }}
        >
          Recharge Amount
        </h3>

        {/* DROPDOWN */}
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "8px",
            marginBottom: "5px",
          }}
        >
          <select
            value={rechargeAmount}
            onChange={(e) => {
              setRechargeAmount(e.target.value);
              setAmountError("");
            }}
            style={{
              width: "100%",
              padding: "10px",
              border: "none",
              outline: "none",
              fontSize: "16px",
              background: "transparent",
            }}
          >
            <option value="">Select Amount</option>
            {amountOptions.map((amount) => (
              <option key={amount} value={amount}>
                ₹{amount}
              </option>
            ))}
          </select>
        </div>

        {/* INLINE ERROR MESSAGE */}
        {amountError && (
          <div style={{ color: "red", marginBottom: "10px", fontSize: "14px" }}>
            {amountError}
          </div>
        )}


        {/* BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "25px",
            gap: "15px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: "#e5e5e5",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            style={{
              padding: "10px 20px",
              background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>

        {/* CONFIRM POPUP */}
        {showConfirmPopup && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10000,
            }}
          >
            <div
              style={{
                width: "450px",
                background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                borderRadius: "16px",
                padding: "30px",
                textAlign: "center",
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              }}
            >
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  background: "white",
                  borderRadius: "50%",
                  margin: "0 auto 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "36px",
                    fontWeight: "bold",
                    color: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                  }}
                >
                  !
                </span>
              </div>

              <h3
                style={{
                  color: "white",
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                }}
              >
                Recharge
              </h3>

              <p
                style={{
                  color: "white",
                  fontSize: "16px",
                  marginBottom: "30px",
                }}
              >
                Are you sure do you want to recharge<strong>{rechargeAmount}</strong> Units now{" "}
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={() => setShowConfirmPopup(false)}
                  style={{
                    padding: "12px 30px",
                    background: "white",
                    color: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  Close
                </button>

                <button
                  onClick={handleConfirmRecharge}
                  style={{
                    padding: "12px 30px",
                    background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  I Confirm To Proceed
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};




const handleSearchCard = async () => {
setError('');

if (!cardName && !mobileNo) {
    setError('Please enter either Card Name or Mobile Number');
    return;
}

try {
    setStudentData(null); 
    if (cardName) {
    const postData = { card_name: cardName };
    setIsLoading(true);
    ManageBranchService.GetSearchStudentByCard(postData)
        .then((res) => {
          if (res.data.code === 201) {
            // No data found
            setStudentData(null);
            alert(res.data.error_message || 'No Cards Registered');
          } else if (res.data.code === 200) {
            setStudentData(res.data.results || null);
            setShowMobile(false);
            
          }
          setIsLoading(false);
        
        })
        .catch((err) => {
        console.error("Fetch failed:", err);
        setError('Failed to fetch student data');
        setIsLoading(false);
        });

    } else {
    const postData = { mobile: mobileNo };
    setIsLoading(true);
    ManageBranchService.GetSearchStudentByMobile(postData)
        .then((res) => {
        if (res.data.code === 201) {
            // No data found
            setStudentData(null);
            alert(res.data.error_message || 'No Cards Registered');
          } else if (res.data.code === 200) {
            if(res.data.results.length > 0){
              setStudentData(res.data.results || null);
              setShowMobile(false);
              
            }else{
               // No data found
            setStudentData(null);
            alert(res.data.error_message || 'No Cards Registered');
            }
            
          }
          setIsLoading(false);
        })
        .catch((err) => {
        console.error("Fetch failed:", err);
        setError('Failed to fetch student data');
        setIsLoading(false);
        });
    }

} catch (err) {
    setError(err.message || 'An error occurred while searching');
    setStudentData(null);
    console.error('Search error:', err);
    setIsLoading(false);
}
};
const SwapCardPopup = ({ data, onClose }) => {
  const [swapPurpose, setSwapPurpose] = useState("");

  const [error, setError] = useState("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);

  if (!data) return null;

  const validateCardNumber = (value) => {
    if (!value) return "Card number is required";
    if (value.length < 5) return "Card number must be at least 5 characters";
    return "";
  };

  const handleCardNumberChange = (value) => {
    debugger;
    setNewCardNumber(value);
    if (error) {
      setError("");
    }
  };

  const validateCardNumberField = (newCardNumber)=>{
       const validationError = validateCardNumber(newCardNumber);
        if (validationError) {
           setError(validationError);
           return false;
        }
         else{
          handleVerifyCard(newCardNumber)
         }
  }

  const handleSubmit = () => {
    debugger
    if(isCardAvailable){
         setShowConfirmPopup(true);
    }else{
      alert("Verify Card")
    }
    // const validationError = validateCardNumber(newCardNumber);

    // if (validationError) {
    //   setError(validationError);
    //   return;
    // }


  };

  const handleConfirmSwap = () => {
    setShowConfirmPopup(false);
    debugger
    const swapData = {
    student_id:data.student_id,
    old_card_id:data.card_id,
    new_card_id: newCardId,
    organization_id:data.organization_id,
    branch_id:data.branch_id,
    description:swapPurpose
      
    };
    setIsLoading(true);
    ManageBranchService.SwapCard(swapData)
    .then((res) => {
        setIsLoading(false);
        alert(res.data.results);
        onClose();
    })
    .catch((res) => {
         setIsLoading(false);
         alert("Something went wrong!");
    });

  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "650px",
          background: "#ffffff",
          borderRadius: "8px",
          padding: "25px",
          boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
            borderRadius: "8px",
            padding: "14px 20px",
            marginBottom: "20px",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: "600",
              color: "#ffffff",
            }}
          >
            Swap Card
          </h2>
        </div>


        {/* STUDENT DETAILS BOX */}
        <div
          style={{
            background: "#f9f9f9",
            padding: "18px",
            borderRadius: "6px",
            border: "1px solid #e5e5e5",
            marginBottom: "25px",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <strong>Card No:</strong> {data.card_name}
            <span style={{ float: "right" }}>
              <strong>Balance:</strong> ₹{data.balance}
            </span>
          </div>

          <div style={{ marginBottom: "6px" }}>
            <strong>Student Name:</strong> {data.student_name}
          </div>

          <div style={{ marginBottom: "6px" }}>
            <strong>Parent:</strong> {data.parent_name}
          </div>

          <div>
            <strong>Relationship:</strong> {data.parent_relation}
          </div>
        </div>

        <h3
          style={{
            marginBottom: "15px",
            fontSize: "18px",
            color: "#444",
            fontWeight: 600

          }}
        >
          Card To Issue
        </h3>

        {/* CARD NUMBER INPUT */}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <div style={{ width: "150px", color: "#555", fontWeight: 500 }}>
              Card Number <span style={{ color: 'red' }}>*</span>
            </div>

            <input
              type="text"
              value={newCardNumber}
              onChange={(e) => handleCardNumberChange(e.target.value)}
              placeholder="Enter new card number"
              style={{
                flexGrow: 1,
                padding: "10px",
                border: error ? "1px solid #dc2626" : "1px solid #ccc",
                borderRadius: "5px",
                marginRight: "10px",
              }}
            />
          </div>
          {error && (
            <div style={{
              color: "#dc2626",
              fontSize: "14px",
              marginLeft: "150px",
              marginBottom: "10px"
            }}>
              {error}
            </div>
          )}
        </div>
       <div>
            <a
              style={{
                color: isCardAvailable ? "green" : "#2563eb",
                textAlign: "center",
                display: "block",
                cursor: isCardAvailable ? "default" : "pointer",
                fontWeight:"600"
              }}
              onClick={() => !isCardAvailable && validateCardNumberField(newCardNumber)}
            >
              {isCardAvailable ? "Verified" : "Verify Card"}
            </a>
            </div>

        {/* BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "25px",
            gap: "15px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: "#e5e5e5",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            style={{
              padding: "10px 20px",
              background:"linear-gradient(to bottom right, #ff7e5f, #feb47b)",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>

       {/* Confirmation Popup */}
{showConfirmPopup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10000,
    }}
    onClick={onClose}

  >
    <div
      style={{
        width: "450px",
        background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
        borderRadius: "16px",
        padding: "30px",
        textAlign: "center",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
      }}
      onClick={(e) => e.stopPropagation()}

    >
      {/* Warning Icon */}
      <div
        style={{
          width: "60px",
          height: "60px",
          background: "white",
          borderRadius: "50%",
          margin: "0 auto 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <span style={{ fontSize: "36px", fontWeight: "bold", color: "#f97316" }}>
          !
        </span>
      </div>

      <h3
        style={{
          color: "white",
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "15px",
        }}
      >
        Are you sure do you want to swap with new card?
      </h3>

      <p
        style={{
          color: "white",
          fontSize: "16px",
          marginBottom: "20px",
          lineHeight: "1.5",
        }}
      >
        Old card will be deleted permanently and any remaining balance will be
        shifted to new card. If yes, please write the purpose of swap.
      </p>

      {/* Purpose Input */}
      <textarea
        placeholder="Enter purpose"
        value={swapPurpose}
        onChange={(e) => setSwapPurpose(e.target.value)}
        style={{
          width: "100%",
          minHeight: "70px",
          padding: "10px",
          borderRadius: "8px",
          border: "none",
          marginBottom: "20px",
          fontSize: "14px",
          outline: "none",
          resize: "none",
        }}
      />

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          gap: "15px",
          justifyContent: "center",
        }}
      >
        <button
          type="button"
          onClick={() => setShowConfirmPopup(false)}
          style={{
            padding: "12px 30px",
            background: "white",
            color: "#f97316",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: "16px",
          }}
        >
          Close
        </button>

        <button
          type="button"
          onClick={handleConfirmSwap}
          disabled={!swapPurpose.trim()}
          style={{
            padding: "12px 30px",
            background: swapPurpose.trim()
              ? "linear-gradient(to bottom right, #ff7e5f, #feb47b)"
              : "#d1d5db",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: swapPurpose.trim() ? "pointer" : "not-allowed",
            fontWeight: "600",
            fontSize: "16px",
          }}
        >
          I Confirm To Proceed
        </button>
      </div>
    </div>
  </div>
)}

      </div>
    </div>
  );
};

const StudentMobilePopup = ({ data, onClose }) => {
const [mobileNumbers, setMobileNumbers] = useState({
    mobile_1: data?.mobile_1 || "",
    mobile_2: data?.mobile_2 || "",
    mobile_3: data?.mobile_3 || "",
    mobile_4: data?.mobile_4 || "",
});
const [errors, setErrors] = useState({});
const [showConfirmPopup, setShowConfirmPopup] = useState(false);

if (!data) return null;

const validateMobileNumber = (value) => {
    if (!value) return "Mobile number is required";
    if (!/^\d{10}$/.test(value)) return "Mobile number must be exactly 10 digits";
    return "";
};

const handleMobileChange = (field, value) => {
    // Allow only digits and limit to 10 characters
    const sanitizedValue = value.replace(/\D/g, "").slice(0, 10);

    setMobileNumbers(prev => ({
    ...prev,
    [field]: sanitizedValue
    }));

    // Clear error for this field when user starts typing
    if (errors[field]) {
    setErrors(prev => ({
        ...prev,
        [field]: ""
    }));
    }
};

const handleUpdate = () => {
    // Validate mobile_1 (required field)
    const mobile1Error = validateMobileNumber(mobileNumbers.mobile_1);

    if (mobile1Error) {
    setErrors({ mobile_1: mobile1Error });
    return;
    }

    // Validate other mobile numbers if they have values
    const newErrors = {};

    if (mobileNumbers.mobile_2 && !/^\d{10}$/.test(mobileNumbers.mobile_2)) {
    newErrors.mobile_2 = "Mobile number must be exactly 10 digits";
    }
    if (mobileNumbers.mobile_3 && !/^\d{10}$/.test(mobileNumbers.mobile_3)) {
    newErrors.mobile_3 = "Mobile number must be exactly 10 digits";
    }
    if (mobileNumbers.mobile_4 && !/^\d{10}$/.test(mobileNumbers.mobile_4)) {
    newErrors.mobile_4 = "Mobile number must be exactly 10 digits";
    }

    if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
    }

    // All validations passed - show confirmation popup
    setShowConfirmPopup(true);
};

const handleConfirmUpdate = () => {
    // Close confirmation popup
    setShowConfirmPopup(false);

    // Prepare data for API
    const updateData = {
    student_id: data.student_id,
    mobile_1: mobileNumbers.mobile_1,
    mobile_2: mobileNumbers.mobile_2,
    mobile_3: mobileNumbers.mobile_3,
    mobile_4: mobileNumbers.mobile_4,
    };
    setIsLoading(true);
    ManageBranchService.UpdateMobileNumbers(updateData)
    .then((res) => {
        setIsLoading(false);
        alert("Mobile numbers updated successfully!");
        onClose();
        handleSearchCard();
    })
    .catch((err) => {
        setIsLoading(false);
        console.error("Update failed:", err);
        alert("Failed to update mobile numbers. Please try again.");
    });
};

return (
    <div
    style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
    }}
    >
    <div
        style={{
        width: "650px",
        background: "#ffffff",
        borderRadius: "8px",
        padding: "25px",
        boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
        }}
    >
         {/* HEADER */}
        <div
          style={{
            background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
            borderRadius: "8px",
            padding: "14px 20px",
            marginBottom: "20px",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: "600",
              color: "#ffffff",
            }}
          >
            Student Details
          </h2>
        </div>

        {/* STUDENT DETAILS BOX */}
        <div
        style={{
            background: "#f9f9f9",
            padding: "18px",
            borderRadius: "6px",
            border: "1px solid #e5e5e5",
            marginBottom: "25px",
        }}
        >
        <div style={{ marginBottom: "8px" }}>
            <strong>Card No:</strong> {data.card_name}
            <span style={{ float: "right" }}>
            <strong>Balance:</strong> ₹{data.balance}
            </span>
        </div>

        <div style={{ marginBottom: "6px" }}>
            <strong>Student Name:</strong> {data.student_name}
        </div>

        <div style={{ marginBottom: "6px" }}>
            <strong>Parent:</strong> {data.parent_name}
        </div>

        <div>
            <strong>Relationship:</strong> {data.parent_relation}
        </div>
        </div>

        <h3
        style={{
            marginBottom: "15px",
            fontSize: "18px",
            color: "#444",
            fontWeight: 600,
        }}
        >
        Mobile Numbers Allowed to Call
        </h3>

        {/* MOBILE FIELDS */}
        {[1, 2, 3, 4].map((num) => (
        <div key={num}>
            <div
            style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
            }}
            >
            <div style={{ width: "150px", color: "#555", fontWeight: 500 }}>
                Mobile Number {num} {num === 1 && <span style={{ color: 'red' }}>*</span>}
            </div>

            <input
                type="text"
                value={mobileNumbers[`mobile_${num}`]}
                onChange={(e) => handleMobileChange(`mobile_${num}`, e.target.value)}
                placeholder="Enter 10 digit mobile number"
                style={{
                flexGrow: 1,
                padding: "10px",
                border: errors[`mobile_${num}`] ? "1px solid #dc2626" : "1px solid #ccc",
                borderRadius: "5px",
                marginRight: "10px",
                }}
            />
            </div>
            {errors[`mobile_${num}`] && (
            <div style={{
                color: "#dc2626",
                fontSize: "14px",
                marginLeft: "150px",
                marginBottom: "10px"
            }}>
                {errors[`mobile_${num}`]}
            </div>
            )}
        </div>
        ))}

        {/* BUTTONS */}
        <div
        style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "25px",
            gap: "15px",
        }}
        >
        <button
            onClick={onClose}
            style={{
            padding: "10px 20px",
            background: "#e5e5e5",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            }}
        >
            Cancel
        </button>

        <button
            onClick={handleUpdate}
            style={{
            padding: "10px 20px",
            background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            }}
        >
            Update
        </button>
        </div>

        {/* Confirmation Popup */}
        {showConfirmPopup && (
        <div
            style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
            }}
        >
            <div
            style={{
                width: "450px",
                background: "#f97316",
                borderRadius: "16px",
                padding: "30px",
                textAlign: "center",
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
            >
            {/* Warning Icon */}
            <div
                style={{
                width: "60px",
                height: "60px",
                background: "white",
                borderRadius: "50%",
                margin: "0 auto 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                }}
            >
                <span style={{ fontSize: "36px", fontWeight: "bold", color: "#f97316" }}>
                !
                </span>
            </div>

            <h3
                style={{
                color: "white",
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "15px",
                }}
            >
                Are you sure do you want to update mobile numbers?
            </h3>

            <p
                style={{
                color: "white",
                fontSize: "16px",
                marginBottom: "30px",
                lineHeight: "1.5",
                }}
            >
                Ask the card holder to update card information at the calling unit to change the mobile numbers in card.
            </p>

            <div
                style={{
                display: "flex",
                gap: "15px",
                justifyContent: "center",
                }}
            >
                <button
                onClick={() => setShowConfirmPopup(false)}
                style={{
                    padding: "12px 30px",
                    background: "white",
                    color: "#f97316",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "16px",
                }}
                >
                Close
                </button>

                <button
                onClick={handleConfirmUpdate}
                style={{
                    padding: "12px 30px",
                    background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: "16px",
                }}
                >
                I Confirm To Proceed
                </button>
            </div>
            </div>
        </div>
        )}
    </div>
    </div>
);
};

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      {/* Loader */}
      <div className="loader" style={IsLoading ? {} : { display: "none" }}>
        <div className="lds-spinner">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i}></div>
          ))}
        </div>
      </div>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>


        <div style={{
          backgroundColor: 'white',
          borderRadius: '24px',
          padding: '32px',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
        }}>
          {/* HEADER */}
              <div
                style={{
                  background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                  borderRadius: "8px",
                  padding: "23px 19px",
                  marginBottom: "32px",
                  display: "flex",
                  alignItems: "center",
                  gap: "360px",
                }}
              >
                <button
                  className="btn btn-outline-light btn-sm"
                  onClick={() => navigate(-1)}
                  style={{
                    fontWeight: "500",
                  }}
                >
                  ← Back
                </button>

                <h1
                  style={{
                    margin: 0,
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#ffffff",
                  }}
                >
                  Search Student
                </h1>
              </div>


          <div style={{ display: 'grid', gap: '20px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: '20px', alignItems: 'end' }}>

              <div>
                <label style={{ color: '#374151', fontSize: '16px', display: 'block', marginBottom: '8px' }}>
                  Card Name
                </label>
                <input
                  type="text"
                  value={cardName}
                  onChange={(e) => setCardName(e.target.value)}
                  placeholder="1831207793"
                  style={{
                    width: '100%',
                    padding: '14px 20px',
                    borderRadius: '12px',
                    border: '2px solid #d1d5db',
                    backgroundColor: 'white',
                    fontSize: '18px',
                    outline: 'none'
                  }}
                />
              </div>

              <div style={{ color: '#374151', fontWeight: 'bold', fontSize: '20px', paddingBottom: '14px' }}>
                OR
              </div>

              <div>
                <label style={{ color: '#374151', fontSize: '16px', display: 'block', marginBottom: '8px' }}>
                  Mobile No
                </label>
                <input
                  type="text"
                  value={mobileNo}
                  onChange={(e) => setMobileNo(e.target.value)}
                  placeholder="9000000001"
                  style={{
                    width: '100%',
                    padding: '14px 20px',
                    borderRadius: '12px',
                    border: '2px solid #d1d5db',
                    backgroundColor: 'white',
                    fontSize: '18px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
              <button
                onClick={handleSearchCard}
                disabled={loading}
                style={{
                  background: 'linear-gradient(to bottom right, #ff7e5f, #feb47b)',
                  fontWeight: '600',
                  padding: '10px 16px',
                  color: 'white',
                  fontSize: '18px',
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer',
                  width: 'fit-content'
                }}
              >
                Search
              </button>
            </div>



            {error && (
              <div style={{
                color: '#dc2626',
                padding: '12px 16px',
                marginTop: '12px'
              }}>
                {error}
              </div>
            )}
          </div>
        </div>

        {/* Student Data Table */}
        {studentData && (
          <div
            style={{
              marginTop: "30px",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            <h2
              style={{ fontSize: "22px", fontWeight: "bold", marginBottom: "20px" }}
            >
              Student Details
            </h2>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{
                      background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                      textAlign: "left",
                      color: "white"
                    }}>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Card Name
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Student Name
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Parent Name
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Relation
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Balance
                  </th>

                  {/* NEW COLUMNS */}
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Mobile No
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Calls
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Recharge
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Swap
                  </th>
                  <th style={{ padding: "12px", borderBottom: "2px solid #e5e7eb" }}>
                    Transactions
                  </th>
                </tr>
              </thead>

              <tbody>
                  {(Array.isArray(studentData) ? studentData : [studentData]).map(
                  (item, index) => (
                    <tr key={item.student_id}>
                      <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                        {item.card_name}
                      </td>
                      <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                        {item.student_name}
                      </td>
                      <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                        {item.parent_name}
                      </td>
                      <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                        {item.parent_relation}
                      </td>
                      <td
                        style={{
                          padding: "12px",
                          borderBottom: "1px solid #e5e7eb",
                          fontWeight: "bold",
                        }}
                      >
                        ₹ {item.balance}
                      </td>

                      {/* NEW COLUMNS */}
                      <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                        <a

                          style={{ color: "#2563eb", cursor: "pointer" }}
                          onClick={() => handleViewMobile(item)}
                        >
                          View Mobile
                        </a>
                      </td>

                      <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                        <a
                            style={{ color: "#2563eb", cursor: "pointer" }}
                            onClick={() =>
                              navigate(
                                `/BranchUser/CardManagement/StudentCallLogs/${item.student_id}`,
                                { replace: true }
                              )
                            }
                          >
                          View Calls
                        </a>
                      </td>

                     <td>
                            <a

                                style={{ color: "#2563eb", cursor: "pointer" }}
                                onClick={() => {
                                setSelectedStudent(item);
                                setshowRechargePopup(true);
                                }}
                            >
                                View Recharge
                            </a>
                     </td>

                      <td>
                            <a
                                style={{ color: "#2563eb" , cursor: "pointer" }}
                                onClick={() => {
                                setNewCardNumber("");
                                setIsCardAvailable(false);
                                setSelectedStudent(item);
                                setShowSwapPopup(true);
                                }}
                            >
                                View Swap
                            </a>
                     </td>

                        <td style={{ padding: "12px", borderBottom: "1px solid #e5e7eb" }}>
                           <a
                            style={{ color: "#2563eb", cursor: "pointer" }}
                            onClick={() =>
                              navigate(
                                `/BranchUser/CardManagement/StudentTransactions/${item.student_id}`,
                                { replace: true }
                              )
                            }
                          >  View Transactions
                          </a>
                          </td>

                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        )}

        {showPopup && (
          <StudentMobilePopup
            data={selectedStudent}
            onClose={() => setShowPopup(false)}
          />
        )}
       {showSwapPopup && (
        <SwapCardPopup
            data={selectedStudent}
            onClose={() => setShowSwapPopup(false)}
        />
        )}
        {showRechargePopup && (
        <RechargeCardPopup
            data={selectedStudent}
            onClose={() => setshowRechargePopup(false)}
        />
        )}

      </div>
    </div>
  );
};

export default SearchCards;